// As defined in
// https://www.notion.so/Use-Cases-7faa5832379344baa175ba783023fa82?pvs=4
const tag = {
  LEAD_GENERATION: 'lead-generation',
  FEEDBACK: 'feedback',
  ANNOUNCEMENT: 'announcement',
  CUSTOMER_SEGMENTATION: 'segmentation',
  COUPONS_OFFERS: 'coupons-offers',
  // AUDIENCE_ENGAGEMENT: 'audience-engagement',
}

const typeTag = {
  POPUP: 'popup',
  FLYOUT: 'flyout',
  GAMIFICATION: 'gamification',
  // FULL_SCREEN: 'full-screen',
}

export { tag, typeTag }